import React from 'react';
import './Copyright.css';

export const Copyright: React.FC = () => {
  return (
    <div className="copyright">
      <p>Copyright David Smith 2026</p>
    </div>
  );
};
